<template>
  <div class="articleEditor container">
    <div class="ab">
      <div class="title1">
        <article-title/>
      </div>
      <div class="title2">
        <home-title :user="user" role="other" :active-tab="activeTab" @changeTab="changeTab"/>
      </div>
      <div class="homeData container">
        <left-tab :active-tab="activeTab" role="other" @changeTab="changeTab"/>
        <div class="rightData">
          <user-collect v-if="activeTab === 'article'" role="other" :user-id="userId"/>
          <user-info @updateUser="updateUser" v-if="activeTab === 'info'" role="other" :user-id="userId"/>
          <user-focus @updateUser="updateUser" v-if="activeTab === 'focus'" role="other" :user-id="userId"/>
          <user-follower @updateUser="updateUser" v-if="activeTab === 'follow'" role="other" :user-id="userId"/>
        </div>
      </div>
    </div>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </div>
</template>
<script>
import articleTitle from '../common/articleTitle.vue'
import homeTitle from './base/homeTitle.vue'
import leftTab from './base/leftTab'
import userInfo from './userInfo'
import userCollect from './userCollect'
import userFocus from './userFocus'
import userFollower from './userFollower'
import loading from '../common/loading.vue'
export default {
  name: 'userHome',
  data () {
    return {
      msg: '他人人中心',
      activeTab: 'article',
      user: null,
      userId: '',
      isLoad: true
    }
  },
  computed: {
  },
  created: function () {
    if (localStorage.getItem('anotherHome_activeTab')) {
      this.activeTab = localStorage.getItem('anotherHome_activeTab')
    }
    let obj = this.$route.params
    let qo = this.$route.query
    // 将数据放在当前组件的数据内
    if (obj.userId) {
      this.userId = obj.userId
      localStorage.setItem('anotherHome_userId', this.userId)
    } else if (qo.userId) {
      this.userId = qo.userId
      localStorage.setItem('anotherHome_userId', this.userId)
    } else if (localStorage.getItem('anotherHome_userId')) {
      this.userId = localStorage.getItem('anotherHome_userId')
    }
    if (this.userId) {
      if (this.userId === this.$root.getUserId()) {
        this.$router.push({
          name: 'userHome'
        })
      } else {
        this.updateUser()
      }
    }
    this.isLoad = false
  },
  mounted: function (s) {
  },
  methods: {
    updateUser: function () {
      this.isLoad = true
      let that = this
      that.axios.post('userInfo', {
        userId: this.userId,
        fromId: this.$root.getUserId()
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          that.user = res
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    changeTab: function (tab) {
      this.activeTab = tab
      localStorage.setItem('anotherHome_activeTab', this.activeTab)
    }
  },
  filters: {},
  components: {
    articleTitle,
    homeTitle,
    leftTab,
    userInfo,
    userCollect,
    userFocus,
    userFollower,
    loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleEditor {
  padding-top: 52px;
}
.ab {
  width: 100%;
  min-width: 1200px;
  background-color: #F0F0F0;
  padding-bottom: 20px;
}
.title1 {
  margin: 0 auto;
  width: 1200px;
  margin-top: 10px;
  text-align: left;
  height: auto;
  font-size: 16px;
  color: #333333;
}
.title2 {
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
}
.homeData {
  width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
}
.rightData {
  float: left;
  width: 950px;
  margin-left: 20px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/user/anotherHome.vue